import React from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import Loader from "shared/Loader";
import Table from "shared/Table";
import styles from "./index.module.css";

export default function Kate({ iboNumber }) {
  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/kate/${iboNumber}`
  );

  let content;

  if (data == null || loading) {
    content = <Loader />;
  } else if (data.length === 0) {
    content = <span>No Kate numbers on record.</span>;
  } else {
    content = (
      <Table>
        <thead>
          <tr>
            <th>Primary Acct.</th>
            <th>Primary Name</th>
            <th>Secondary Acct.</th>
            <th>Secondary Name</th>
            <th>Phone</th>
            <th>Deactivated</th>
          </tr>
        </thead>
        <tbody>
          {data.map((k, i) => {
            return (
              <tr key={i}>
                <td>{k.primaryAccount}</td>
                <td>{k.primaryName}</td>
                <td>{k.secondaryAccount}</td>
                <td>{k.secondaryName}</td>
                <td>{k.phone}</td>
                <td>{k.deactivated ? "Yes" : "No"}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  return <div className={styles.container}>{content}</div>;
}
